import { useTranslation } from "react-i18next";

import { UpdateProfileForm } from "@/pages/gate/UpdateProfilePage.tsx";

interface Language {
  id: number;
  value: keyof Pick<UpdateProfileForm, "content_all" | "content_ru" | "content_uz">;
  text: string;
}

export const useContentLanguages = (): Language[] => {
  const { t } = useTranslation();

  return [
    {
      id: 1,
      value: "content_all",
      text: t("General.all"),
    },
    {
      id: 2,
      value: "content_ru",
      text: t("language-ru"),
    },
    {
      id: 3,
      value: "content_uz",
      text: t("language-uz"),
    },
  ];
};
